import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { API_ENDPOINTS } from "../../../constants/endPoints";
import useApiRequest from "../../../hook/useApiRequest";

const usePagesList = () => {
  const { loading, fetchData } = useApiRequest();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [listData, setListData] = useState({});
 
  const [filters, setFilters] = useState({
    startDate: "",
    endDate: "",
    search: "",
  });

  const limit = API_ENDPOINTS?.page_limit;
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const fetchCustomerData = async () => {
    try {
      const url = `${API_ENDPOINTS?.get_pages}`;
      const params = {
        offset: currentPage,
        limit: limit,
        search: filters.search || "",
        startDate: filters.startDate || "",
        endDate: filters.endDate || "",
      };
      const response = await fetchData(
        `${url}?${new URLSearchParams(params)}`,
        navigate
      );
      if (response) {
        setListData(response);
      }
    } finally {
    }
  };

  
  const handleSearch = (filtervalue) => {
    setFilters((prev) => ({ ...prev, search: filtervalue }));
  };

  const handleFilter = (filtervalue) => {
    setFilters(filtervalue);
  };

  useEffect(() => {
    fetchCustomerData();
 
  }, [currentPage, filters]);



  return {
    listData,
    loading,
    currentPage,
    limit,
    fetchCustomerData,
    handleSearch,
    handleFilter,
    handlePageChange,
  
  };
};

export default usePagesList;
